const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const getLeadTimes = async () =>
  fetch("/api/windowdoor/leadtimes").then((res) => res.json());

export const saveLeadTimeBrand = async (payload) =>
  fetch("/api/windowdoor/leadtimes/save", {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
  }).then((res) => res.json());

export const deleteLeadTimeBrand = async (brandKey) =>
  fetch(`/api/windowdoor/leadtimes/${encodeURIComponent(brandKey)}`, {
    method: "DELETE",
  }).then((res) => res.json());

export const getLeadTimeRecipients = async () =>
  fetch("/api/windowdoor/leadtimes/recipients").then((res) => res.json());

export const previewLeadTimeEmail = async (brandKey) =>
  fetch("/api/windowdoor/leadtimes/email/preview", {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ brandKey }),
  }).then((res) => res.json());

export const sendLeadTimeEmail = async (payload) =>
  fetch("/api/windowdoor/leadtimes/email/send", {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
  }).then((res) => res.json());
